import * as React from "react";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import { useState, useEffect } from "react";
import { streamsLoad } from "../../appRedux/ducks/pastStreams";
import { connect } from "react-redux";

function PaginationComponent({
  videoKey,
  fetchStreams,
  total,
  customPageSize,
}) {
  const [page, setPage] = useState(1);
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isSmall = width < 500;
  const isMobile = width <= 768;

  function handlePageChange(e, newPage) {
    setPage(newPage);
  }

  useEffect(() => {
    fetchStreams(videoKey, page, total, customPageSize);
  }, [page, videoKey]);

  const count = Math.ceil(total / customPageSize);

  const smallProps = {
    boundaryCount: 3,
    siblingCount: 0,
    showFirstButton: true,
    showLastButton: true,
  };

  const mobileProps = {
    boundaryCount: 0,
    siblingCount: 1,
    showFirstButton: true,
    showLastButton: true,
  };

  const desktopProps = {
    boundaryCount: 3,
    siblingCount: 1,
    showFirstButton: true,
    showLastButton: true,
  };

  const paginationProps = isSmall
    ? smallProps
    : isMobile
      ? mobileProps
      : desktopProps;

  const renderItem = isSmall
    ? (item) => {
        if (item.type === "start-ellipsis" || item.type === "end-ellipsis") {
          return null;
        }
        if (item.type === "page" && item.page > 3) {
          return null;
        }
        return <PaginationItem {...item} />;
      }
    : undefined;

  return (
    <Pagination
      size="large"
      shape="circular"
      page={page}
      onChange={handlePageChange}
      count={count}
      renderItem={renderItem}
      sx={
        isSmall
          ? { ".MuiPagination-ul > li:empty": { display: "none" } }
          : undefined
      }
      {...paginationProps}
    />
  );
}
const stateToProps = (state) => ({
  pastStreams: state.streams.streams,
  loading: state.streams.loading,
  total: state.streams.total,
});
const dispatchToProps = (dispatch) => ({
  fetchStreams: (endpoint, page, total, per_page) =>
    dispatch(streamsLoad(endpoint, page, total, per_page)),
});
export default connect(stateToProps, dispatchToProps)(PaginationComponent);
